function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0up{fill:#F0F0F0;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 3.85,
  y: 30.09,
  className: "st0up",
  width: 29.92,
  height: 0.85
}), /*#__PURE__*/React.createElement("path", {
  className: "st0up",
  d: "M32.21,35.65H6.27C2.81,35.65,0,32.84,0,29.38V18.12h0.85v11.26c0,2.98,2.43,5.41,5.41,5.41h25.94 c2.98,0,5.41-2.43,5.41-5.41V18.12h0.85v11.26C38.47,32.84,35.66,35.65,32.21,35.65z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.11,
  y: 0.95,
  className: "st0up",
  width: 1.36,
  height: 26
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0up",
  points: "8,13.01 7.07,12.02 19.8,0 31.84,12.04 30.88,13 19.77,1.9  "
}));

var SvgMenuUpload = function SvgMenuUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.47 35.65",
    style: {
      enableBackground: "new 0 0 38.47 35.65"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu_Upload.165e7c41.svg";
export { ForwardRef as ReactComponent };